const UserTypes = [
  {
    id: 'admin',
    name: 'admin',
  },
  {
    id: 'agent',
    name: 'agent',
  },
  {
    id: 'landlord',
    name: 'landlord',
  },
  {
    id: 'unit_owner',
    name: 'unit_owner',
  },
  {
    id: 'caretaker',
    name: 'caretaker',
  },
];

export default UserTypes;
